import { RegistrationStatus } from '@exam-center/graphql';

const SAVE_EXAM_EVENT_SNACKBAR_MESSAGE = {
  pending: 'กำลังบันทึกรอบการสอบ',
  success: 'บันทึกรอบการสอบเรียบร้อยแล้ว',
  error: 'ไม่สามารถบันทึกรอบการสอบได้',
};

const OPEN_REGISTRATION_EXAM_EVENT_SNACKBAR_MESSAGE = {
  pending: 'กำลังเปิดรับสมัคร',
  success: 'เปิดรับสมัครเรียบร้อยแล้ว',
  error: 'ไม่สามารถเปิดรับสมัครได้',
};

const TEMPORARILY_CLOSE_EXAM_EVENT_SNACKBAR_MESSAGE = {
  pending: 'กำลังปิดรับสมัครชั่วคราว',
  success: 'ปิดรับสมัครชั่วคราวเรียบร้อยแล้ว',
  error: 'ไม่สามารถปิดรับสมัครชั่วคราวได้',
};

const CANCEL_EXAM_EVENT_SNACKBAR_MESSAGE = {
  pending: 'กำลังยกเลิกรอบการสอบ',
  success: 'ยกเลิกรอบสอบเรียบร้อยแล้ว',
  error: 'ไม่สามารถยกเลิกรอบการสอบได้',
};

interface GetSnackbarMessageByNewStatusArgs {
  from: RegistrationStatus;
  to: RegistrationStatus;
}

export function getSnackbarMessageByNewStatus(args: GetSnackbarMessageByNewStatusArgs) {
  const { from: currentStatus, to: newStatus } = args;

  const isStatusChanged = currentStatus !== newStatus;
  if (!isStatusChanged) return SAVE_EXAM_EVENT_SNACKBAR_MESSAGE;

  switch (newStatus) {
    case RegistrationStatus.OpenForRegistration:
      return OPEN_REGISTRATION_EXAM_EVENT_SNACKBAR_MESSAGE;
    case RegistrationStatus.TemporarilyClosed:
      return TEMPORARILY_CLOSE_EXAM_EVENT_SNACKBAR_MESSAGE;
    case RegistrationStatus.Canceled:
      return CANCEL_EXAM_EVENT_SNACKBAR_MESSAGE;
    default:
      return SAVE_EXAM_EVENT_SNACKBAR_MESSAGE;
  }
}
